export const escapeRegExp = (string) => string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); // $& means the whole matched string
export const storeProductVariantAppendix = (customVariants) => new RegExp(`(\\s(Color|Size${customVariants?.length
    ? '|' + customVariants.map(escapeRegExp).join('|')
    : ''}):\\s.+;)+?\\s*$`);
//# sourceMappingURL=regex.js.map